import { Injectable } from '@angular/core';
import firebase, { User } from 'firebase/app';
import 'firebase/database';

@Injectable()
export class ProfileProvider {

    public hasLoaded: Promise<void>;

  public userProfile: firebase.database.Reference;
  public currentUser: User;

  constructor() {
        this.hasLoaded = new Promise((resolve) => {
            firebase.auth().onAuthStateChanged( user => {

                if(user){
                    this.currentUser = user;
                    this.userProfile = firebase.database().ref(`/userProfile/${user.uid}`);

                }
                resolve();
            });
        });
  
  }

  getUserProfile(): firebase.database.Reference {
   
    return this.userProfile;
  }

  updateName(firstName: string, lastName: string): Promise<any> {
    return this.userProfile.update({ firstName, lastName });
  }

  updateRole(role: string): Promise<any> {
    return this.userProfile.update({ role });
  }

  updateDOB(birthDate:string): Promise<any> {
    return this.userProfile.update({ birthDate });
  }

  updateEmail(newEmail: string, password: string): Promise<any> {
    const credential: firebase.auth.AuthCredential = firebase.auth.
      EmailAuthProvider.credential(
        this.currentUser.email,
        password
      );
    return this.currentUser
      .reauthenticateWithCredential(credential)
      .then(user => {
        this.currentUser.updateEmail(newEmail).then(user => {
          this.userProfile.update({ email: newEmail });
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  updatePassword(newPassword: string, oldPassword: string): Promise<any> {
    const credential: firebase.auth.AuthCredential = firebase.auth
      .EmailAuthProvider.credential(
        this.currentUser.email,
        oldPassword
      );

    return this.currentUser
      .reauthenticateWithCredential(credential)
      .then(user => {
        this.currentUser.updatePassword(newPassword).then(user => {
          console.log('Password Changed');
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  deleteAccount(password: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const credential = firebase.auth.EmailAuthProvider.credential(this.currentUser.email, password);

      const dbRef = firebase
			.database()
			.ref(`/userProfile/${this.currentUser.uid}`);

      this.currentUser
        .reauthenticateWithCredential(credential)
        .then(() => {
          dbRef.remove().then(() => {
            this.currentUser.delete().then(() => {
              resolve(true);
            }).catch(error => {
              reject(error);
            });
          }).catch(error => {
            reject(error);
          });
        })
        .catch(error => {
          reject(error);
        });
    })
  }

  

}



// WEBPACK FOOTER //
// ./src/providers/profile/profile.ts